import { Reveal } from "@/components/site/Reveal";
import { ABOUT, COMPANY } from "@/data/content";

export default function About() {
  return (
    <section
      id="about"
      className="relative border-t border-white/10 bg-[#050505] py-24 md:py-40"
      data-testid="about-section"
    >
      <div className="mx-auto grid max-w-[1600px] grid-cols-1 gap-12 px-5 md:grid-cols-12 md:px-10">
        <div className="md:col-span-7">
          <Reveal>
            <span className="font-mono text-xs uppercase tracking-[0.3em] text-[#0033ff]">
              {ABOUT.overline}
            </span>
            <h2 className="mt-6 font-display text-3xl font-extrabold uppercase leading-[0.95] tracking-tighter text-[#f4f4f5] md:text-4xl lg:text-5xl">
              {ABOUT.heading}
            </h2>
          </Reveal>

          <div className="mt-10 max-w-xl space-y-6">
            {ABOUT.bio.map((p, i) => (
              <Reveal key={i} delay={0.1 * i}>
                <p className="font-mono text-sm leading-relaxed text-[#a1a1aa]">{p}</p>
              </Reveal>
            ))}
          </div>

          <div className="mt-12 grid grid-cols-1 border-t border-white/10 sm:grid-cols-3">
            {ABOUT.stats.map((s, i) => (
              <Reveal key={s.k} delay={0.1 * i}>
                <div className="border-b border-white/10 py-6 sm:border-b-0 sm:border-r sm:pr-6 last:sm:border-r-0">
                  <div className="font-mono text-[10px] uppercase tracking-[0.25em] text-[#52525b]">
                    {s.k}
                  </div>
                  <div className="mt-2 font-display text-base font-bold text-[#f4f4f5]">
                    {s.v}
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>

        {/* Founder portrait — clipped, grayscale */}
        <div className="md:col-span-5">
          <Reveal delay={0.15}>
            <div className="relative overflow-hidden bg-[#0c0c0c]">
              <img
                src="https://customer-assets-jt897jd0.emergentagent.net/job_deck-2-website/artifacts/wxewbk8l_nishant_zaveri_photo_02.jpg"
                alt="Founder portrait"
                loading="lazy"
                className="block h-[420px] w-full object-cover object-top founder-photo"
                data-testid="founder-image"
              />
              <div className="pointer-events-none absolute inset-0 border border-white/20" />
              <div className="absolute bottom-0 left-0 right-0 flex items-end justify-between border-t border-white/20 bg-[#050505]/85 px-5 py-4 backdrop-blur">
                <div>
                  <div className="font-display text-sm font-bold uppercase tracking-tight text-white">
                    {COMPANY.founder}
                  </div>
                  <div className="mt-1 font-mono text-[10px] uppercase tracking-[0.2em] text-[#a1a1aa]">
                    Proprietor
                  </div>
                  <div className="mt-0.5 font-mono text-[10px] uppercase tracking-[0.2em] text-[#a1a1aa]">
                    Technical Architect
                  </div>
                </div>
                <span className="font-mono text-[10px] text-[#0033ff]">/ EST.</span>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
